import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Fase 0 — `sanitizeFolio` (puro) se movió a @/domain/folio; se re-exporta para compatibilidad.
export { sanitizeFolio } from "@/domain/folio";
